const NS = 'MarketForecastTableBlock';
const CLS = 'marketForecastTableBlock';

import { TableBlock } from '../../tableBlock/js/tableBlock';

export class MarketForecastTableBlock extends TableBlock {
	constructor(element) {
		super(element, CLS);

		this.api = this.$element.attr('data-api');

		this.getTableDataFromApi();
	}

	setTableData() {
		this.columnDefs = [
			{
				field: 'dateObject',
				cellRenderer: this.marketForecastDateCellRenderer,
				headerName: '',
				minWidth: 100,
				lockPosition: true
			},
			{
				field: 'projectionValue',
				minWidth: 100,
				lockPosition: true,
				valueFormatter: (params) => {
					return params.data.projectionValueDisplayText;
				}
			},
			{
				field: 'actualValue',
				minWidth: 100,
				lockPosition: true,
				valueFormatter: (params) => {
					return params.data.actualValueDisplayText;
				}
			}
		];
	}

	setGridOptions() {
		super.setGridOptions({
			rowHeight: 46
		});
	}

	marketForecastDateCellRenderer(params) {
		let date = !_.isNil(params.value) && !_.isNil(params.value.date) ? params.value.date : null;
		let week = !_.isNil(params.value) && !_.isNil(params.value.week) ? params.value.week : null;

		return `
			<div class="cell-week">Week ${week ? week : '-'}</div>
			<div class="cell-date">${date ? date : '-'}</div>
		`;
	}

	getTableDataFromApi() {
		let url = this.api;

		if(!_.isEmpty(this.urlParams)) {
			url += `?${$.param(this.urlParams)}`;
		}

		if(this.api) {
			$.ajax({
				type: 'GET',
				url: url,
				dataType: 'json',
				success: (response) => {
					if(response && response.values && response.values.length > 0) {
						this.gridOptions.api.getColumnDef('projectionValue').headerName = response.currentFinancialYear ? `${response.currentFinancialYear} Projection` : 'Projection';
						this.gridOptions.api.getColumnDef('actualValue').headerName = response.previousFinancialYear ? `${response.previousFinancialYear} Actual` : 'Actual';
						this.gridOptions.api.refreshHeader();

						this.$element.trigger(`${CLS}.update`, {
							data: response.values
						});
					}
					else {
						this.$element.trigger(`${CLS}.update`, {
							data: null,
							isEmpty: true
						});
					}
				},
				error: () => {
					this.$element.trigger(`${CLS}.update`, {
						data: null,
						isError: true
					});
				}
			});
		}
		else {
			console.error(`${NS}::Error`, 'API is not set.');
			this.$element.trigger(`${CLS}.update`, {
				data: null
			});
		}
	}
}
